import axiosGlobalInstance from '../http-instance';
import { getCookie, decryptAes } from '../../utils';

export default params => {
  const userLoggedState = getCookie();
  const decipher = decryptAes(userLoggedState);

  const formattedParams = {
    cityId: params.cityId,
    name: params.name,
  }

  return axiosGlobalInstance({
    method: 'GET',
    url: 'bairro.php',
    headers: {
      token: decipher?.token?.value,
      action: 'list'
    },
    params: {
      ...formattedParams,
      // timestamp: new Date().getTime()
    },
  })
}
